import { usePetitionDetails } from '../../../../../../hooks/petitionDetails';
import { ScrollTrackingWaypointContainer } from '../../../../../ScrollTrackingWaypoint';
import { useSignaturesDistributionContext } from '../../shared/provider';
import { SignatureDistributionSummary } from '../SignatureDistributionSummary';
import { SignatureMap } from '../SignatureMap';

type Props = {
	isStaff: boolean;
};

export function SignaturesDistributionInfo({ isStaff }: Props): React.JSX.Element | null {
	const { id } = usePetitionDetails();
	const {
		data: { isLoadingData, isCrunchingData, signaturesClusters, clusterPercentage },
	} = useSignaturesDistributionContext();

	return (
		<>
			{!isLoadingData && !isCrunchingData && signaturesClusters && clusterPercentage !== undefined && (
				<div className="mt-4 mb-2 flex flex-col">
					<ScrollTrackingWaypointContainer
						name="petition_sign_map_view"
						trackingData={{ petition_id: id, is_staff: isStaff }}
					/>
					<SignatureMap
						signaturesClusters={signaturesClusters}
						clusterPercentage={clusterPercentage}
						isStaff={isStaff}
					/>
					<SignatureDistributionSummary signaturesClusters={signaturesClusters} clusterPercentage={clusterPercentage} />
				</div>
			)}
		</>
	);
}
